import React from 'react';
import { createRoot } from 'react-dom/client';
import './app/firebase';
import { Provider } from 'react-redux';
import { store } from './app/store';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './index.css';
import './i18n';
import '@/app/utils/custom_function'
import {pdfjs} from "react-pdf";

const container = document.getElementById('root')!;
const root = createRoot(container);

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;
console.log("PDF Worker URL:", pdfjs.GlobalWorkerOptions.workerSrc);

root.render(
  // <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
